"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledRelationshipWarning = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const utils_1 = require("../lib/utils");
const styles_1 = require("../styles");
const messages_1 = require("../lib/messages");
exports.DisabledRelationshipWarning = (0, intl_1.injectIntl)(({ purposeOptionsByRelationship, intl }) => {
    const disabledRelationships = (0, utils_1.getDisabledRelationships)(purposeOptionsByRelationship);
    if (disabledRelationships.new === false &&
        disabledRelationships.established === false) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(styles_1.DisabledWarningBanner, { icon: "!", type: "warning", style: { lineHeight: 1.42857 }, "data-testid": "disabled-relationship-warning" },
        disabledRelationships.new && (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.messages.disabledPatientRelationshipWarning, { values: {
                relationship: intl
                    .formatMessage(messages_1.messages.newPatientWarningBannerLabel)
                    .toLocaleLowerCase()
            } }))),
        disabledRelationships.established && (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.messages.disabledPatientRelationshipWarning, { values: {
                relationship: intl
                    .formatMessage(messages_1.messages.establishedPatientWarningBannerLabel)
                    .toLocaleLowerCase()
            } })))));
});
//# sourceMappingURL=DisabledRelationshipWarning.js.map